import ResponseBody_vue_vue_type_script_setup_true_lang_default from "./ResponseBody.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ResponseBody/ResponseBody.vue
var ResponseBody_default = ResponseBody_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ResponseBody_default as default };

//# sourceMappingURL=ResponseBody.vue.js.map